import BusinessError from './BusinessError';

export class UnauthenticatedUser extends BusinessError {
  constructor(message = 'server.authentication.unauthenticatedUser', status = 403) {
    super('UnauthenticatedUser', status, message);
    Error.captureStackTrace(this, UnauthenticatedUser);
  }
}

export class IncorrectPassword extends BusinessError {
  constructor(message = 'server.authentication.incorrectPassword', status = 401) {
    super('IncorrectPassword', status, message);
    Error.captureStackTrace(this, IncorrectPassword);
  }
}

export class ExpiredToken extends BusinessError {
  constructor(message = 'server.authentication.tokenExpired', status = 401) {
    super('ExpiredToken', status, message);
    Error.captureStackTrace(this, ExpiredToken);
  }
}

export class InvalidToken extends BusinessError {
  constructor(message = 'server.authentication.tokenInvalid', status = 401) {
    super('InvalidToken', status, message);
    Error.captureStackTrace(this, InvalidToken);
  }
}
